import ConsentStorage from './ConsentStorage';
import { ConsentKey } from './types';

const CookiesManager = {
    onConsentFirstGiven: () => {
        // here we can react on Iubenda events. Callbacks are configured through Iubenda interface
    },
    onPreferenceExpressed: (args: { purposes: Record<ConsentKey, boolean> }) => {
        const { purposes } = args;

        const storage = ConsentStorage.getInstance();

        (Object.keys(purposes) as unknown as ConsentKey[]).forEach((key) => {
            storage.setConsent(key, purposes[key]);
        });
    }
};

export default CookiesManager;
